// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import DocumentationPage from './DocumentationPage';

export default DocumentationPage;
